/**
 * アンケート質問の入力フォームタイプ（q.type）の定義
 */
export const QUESTION_TYPE = {
  TEXT: "text",
  TEXTAREA: "textarea",
  SELECT: "select",
  RADIO: "radio",
  CHECKBOX: "checkbox",
};
